import React from 'react';
import about from '../../images/about me.png';
import FocusButton from '../Shared/FocusButton';

const AboutMe = () => {
    return (
        <div id='aboutMe' className='bg-base-200'>
            <h1 class="text-4xl font-bold text-center text-primary pt-6">About Me</h1>
            <div class="hero min-h-screen">
            
                <div class="hero-content flex-col lg:flex-row px-12">
                    <img src={about} class="max-w-sm rounded-lg shadow-2xl" />
                    <div className='lg:pl-12'>
                       
                        <br />
                        <br />
                        <p class="py-4">I am a fresher developer. I've been learning web development for one year. During my web developer course, I developed numerous skills and strengtherned my existing abilities. My web dev course developed my aptitude with object oriented programming. </p>
                        <p class="py-4">I am also a university student. I study in Computer Science and Technology at Changsha University of Science and Technology, China. </p>
                        <p class="py-4">My goal is to gain confidence and fame using my potential in the field of web development and express my innovative creative skills for self and company growth.</p>
                        <br />
                        <br />

                        <FocusButton>
                            <a href="https://drive.google.com/file/d/1wb47FF1JyXgDJGgdYIEWt-v-u-_OcAFJ/view?usp=sharing">Download Resume</a>
                        </FocusButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;